<template>
  <div class="main-box">
    <el-card class="box-card" shadow="never">
      登录日志
    </el-card>
  </div>
</template>

<script>
export default {
  name: "LoginLog"
}
</script>

<style scoped>
.main-box {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.box-card {
  flex: 1;
}
</style>
